import { Action } from 'redux';
import type { ServicesInsightsReport } from 'model/ServicesInsightsReport';

export const SERVICES_INSIGHTS_REPORT_GET_START = 'SERVICES_INSIGHTS_REPORT_GET_START';
export const SERVICES_INSIGHTS_REPORT_GET_SUCCESS = 'SERVICES_INSIGHTS_REPORT_GET_SUCCESS';
export const SERVICES_INSIGHTS_REPORT_GET_ERROR = 'SERVICES_INSIGHTS_REPORT_GET_ERROR';

type ServicesInsightsGetStartAction = Action<typeof SERVICES_INSIGHTS_REPORT_GET_START>;

interface ServicesInsightsGetSuccessAction extends Action<typeof SERVICES_INSIGHTS_REPORT_GET_SUCCESS> {
    payload: {
        report: ServicesInsightsReport;
    };
}

type ServicesInsightsGetErrorAction = Action<typeof SERVICES_INSIGHTS_REPORT_GET_ERROR>;

export type ServicesInsightsReportAction =
    | ServicesInsightsGetStartAction
    | ServicesInsightsGetSuccessAction
    | ServicesInsightsGetErrorAction;
